<template>
    <kiosk-layout formContainer>
        <step-form-heading :icon="faBuildingFlag"> New Organizational Unit </step-form-heading>

        <form-wrapper :sections="[{ id: 'details', label: 'Details' }]">
            <kiosk-org-unit-form-details id="details" v-model="form" />

            <vx-sticky-footer>
                <vx-button href="/kiosk/org-units" class="w-20" size="lg" color="muted"> Cancel </vx-button>
                <vx-button
                    @click="submit()"
                    data-test="submit-button"
                    class="grow"
                    size="lg"
                    color="primary"
                    :loading="processing"
                >
                    Create Organizational Unit
                </vx-button>
            </vx-sticky-footer>
        </form-wrapper>
    </kiosk-layout>
</template>

<script setup>
import KioskLayout from '../../KioskLayout.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import FormWrapper from '~/components/general/FormWrapper.vue';
import { VxStickyFooter, VxButton } from '@voxie/frontend-components';
import { ref } from 'vue';
import KioskOrgUnitFormDetails from './KioskOrgUnitFormDetails.vue';
import { useFormSubmission } from '~/composables/useFormSubmission';
import { adminOrgUnitsClient } from '~/services';
import { faBuildingFlag, faSquareArrowUpLeft } from '@fortawesome/pro-solid-svg-icons';

const defaultData = () => ({
    team_id: null,
    name: '',
    hubspot_company_id: null,
});

const form = ref(defaultData());

const save = async () => {
    const response = await adminOrgUnitsClient.createOrgUnit(form.value.team_id, {
        name: form.value.name,
        hubspot_company_id: form.value.hubspot_company_id,
    });
    return response;
};

const { submit, processing } = useFormSubmission({
    data: form,
    preserveScroll: false,
    reset: () => {
        // if update functionality is added to this form, the data should not be cleared
        form.value = defaultData();
    },
    submit: save,
    notification: () => ({
        message: 'Organizational Unit created',
        action: {
            icon: faSquareArrowUpLeft,
            label: 'Back to Organizational Units',
            href: '/kiosk/org-units',
        },
    }),
});
</script>
